import styled from '@emotion/native';
import { Card } from '../../Component';

export default styled(Card)({
  minHeight: 520,
  width: 400,
});
